import {
  ADD_SELECTED_VIDEO,
  REMOVE_SELECTED_VIDEO,
  WIDGET_STATES,
  CLEAR_SELECTED_VIDEOS,
  UPDATE_VIDEO_SETTINGS,
} from "./WidgetAction";

const _nullState = {
  activeStep: 1,
  createCarousel: false,
  update_widget: false,
  openCodePopup: false,
  openNotesPopup: false,
  openPopup: false,
  enableSearch: true,
  enableSorting: true,
  enableTag: true,
  enableBrandTag: true,
  enableRatingVideo: true,
  enableCarouselName: true,
  productRatingVideo: false,
  enableHighlight: true,
  video_summary: true,
  key_thumbnails: true,
  key_highlights: true,
  is_edit: false,
  video_caption: true,
  product_img: true,
  show_product: true,
  show_variant: true,
  product_price: true,
  custom_color: false,
  play_button: false,
  powered_by_vyrill: true,
  selected_color: "#409DB2",
  play_button_color: "#fff",
  selectedVideos: [],
  carousels_data: [],
  single_widget_data: "",
  activeRatio: "Portrait",
  title: "",
  notes: "",
  page: "",
  discardModal: false,
  showAnnotation: true,
  call_to_action: false,
  button_copy: "",
  button_URL: "",
  menu_options: ["most_recent", "ratings", "verified_shopper", "brand_video"],
  device_options: ["desktop", "mobile"],
  advance_search: [""],
  selected_platform: "",
  update_widget_id: "",
  playlist_id: "",
  selectedTab: "videocarousel",
  selectedVideosTab: "selectedVideosTab",
  updated_message: "",
  gridView: true,
  next_video: 0,
  buy_now_button: false,
  cart_button: false,
  button_color: "#783AD0",
  button_text_color: "black",
  buy_now_text_color: "black",
  cart_text_color: "black",
  button_color_stroke: "#783AD0",
  buy_now_color: "#783AD0",
  cart_color: "#783AD0",
  buy_now_color_stroke: "#783AD0",
  cart_color_stroke: "#783AD0",
  cta_fill: false,
  cta_stroke: false,
  buy_now_fill: false,
  cart_fill: false,
  buy_now_stroke: false,
  cart_stroke: false,
  video_data: null,
};

export const widget_states = (
  state = _nullState,
  { type, status, payload }
) => {
  switch (type) {
    case ADD_SELECTED_VIDEO:
      return {
        ...state,
        selectedVideos: [
          ...state.selectedVideos,
          {
            video_id: payload.video_id,
            thumbnail_url: payload.thumbnail_url,
            title: payload.title,
            settings: payload.settings || {
              video_summary: true,
              key_thumbnails: true,
              key_highlights: true,
              video_caption: true,
              product_img: true,
              show_product: true,
              show_variant: true,
              product_price: true,
              productRatingVideo: true,
              call_to_action: false,
              buy_now_button: false,
              cart_button: false,
              button_color: "#783AD0",
              button_color_stroke: "#783AD0",
              buy_now_color: "#783AD0",
              cart_color: "#783AD0",
              buy_now_color_stroke: "#783AD0",
              cart_color_stroke: "#783AD0",
              button_text_color: "black",
              buy_now_text_color: "black",
              cart_text_color: "black",
              button_copy: "",
              button_URL: "",
              cta_fill: false,
              cta_stroke: false,
              buy_now_fill: false,
              cart_fill: false,
              buy_now_stroke: false,
              cart_stroke: false,
            },
          },
        ],
      };
    case UPDATE_VIDEO_SETTINGS:
      return {
        ...state,
        selectedVideos: state.selectedVideos.map((video) =>
          video.video_id === payload.videoId
            ? {
                ...video,
                settings: { ...video.settings, ...payload.newSettings },
              }
            : video
        ),
      };
    case REMOVE_SELECTED_VIDEO:
      return {
        ...state,
        selectedVideos: state.selectedVideos.filter(
          (video) => video.video_id !== payload
        ),
      };
    case CLEAR_SELECTED_VIDEOS:
      return {
        ...state,
        selectedVideos: [],
      };
    case WIDGET_STATES:
      return { ...state, ...status };
    default:
      return state;
  }
};
